module.exports = __webpack_public_path__ + "static/media/consultorio-04.5198b973.JPG";